import { SelectAdditionalPackage } from "@nju/feature-portal-additional-packages";
import {
  NavigationWithUserContext,
  RequiredDashboardData,
} from "@nju/feature-portal-dashboard";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function SelectAdditionalPackagePage() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="narrow" spacing="xl" tone="gray">
        <RequiredDashboardData extendedMode="mobile">
          <NavigationWithUserContext />
          <SelectAdditionalPackage showBackButton={true} />
        </RequiredDashboardData>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
